<template>
  <div>
      <el-form v-if="isShowBusinessTree" size="mini" :inline="true">
        <el-row >
          <!-- <el-col style="margin-left:-95px;" :span="12"> -->
          <el-col :span="12">
            <el-tooltip content="新增数据可以选择，修改数据需要分配权限后可以修改" effect="light" placement="top">
              <el-form-item label="业务分类" :rules="[{ required: isRequired, message: '请输入档案模板名称', trigger: 'blur' },]">
                <BusinessTree ref="treeChild" :rootId="rootId" :isRead="isBelongApproval || isEditAuth" :selectedNode='selectedNode' :defaultClass="'business-tree-form'" :popover="true" @nodeClick="handleTreeNode" />
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="12">
            <el-form-item label="档案模板" :rules="[{ required: isRequired, message: '请输入档案模板名称', trigger: 'blur' },]">
                <ArchiveTemplateList 
                    v-if="isShowArchiveTemplateList"
                    :key='loadTimerArchive'
                    ref="archiveTemplateList"
                    :field="field"
                    :isRead="isEditAuth"
                    :businessTreeId="businessTreeId"
                    :selectedNode='selectedNodeTemplate'
                    @nodeClick="handleArchiveTemplateChange"
                />
            </el-form-item>
            <el-button  v-if="templateId" class='print-class' type="primary" icon="el-icon-printer" size="mini" @click.stop="archiveDirExport()">导出目录</el-button>
          </el-col>
        </el-row>
      </el-form>
      <!-- 完全模式 -->
      <el-table 
        v-if="tableModelType == '1'"
        :key='loadTimer'
        :data="currentPageList"  
        ref="multipleTable"
        row-key="randomId" 
        default-expand-all
        style="width: 100%; " 
        max-height="520"
        :tree-props="{children: 'children'}"
        :border="true" 
        @select="handleSelect"
        @select-all="handleSelectAll"
        @selection-change="handleSelectionChange"
        v-loading="loading">
            <el-table-column type="selection" width="55"></el-table-column>
            <!-- <el-table-column type="index" width="50"> </el-table-column> -->
            <el-table-column prop="orderNum" label="序号" width="50"> </el-table-column>
            <el-table-column prop="label" label="文件名称" width="300" >
                <!-- <template  slot-scope="scope" >
                  <el-button v-if="scope.row.dir" icon="el-icon-message" plain> {{ scope.row.label }}</el-button>
                  <span v-else  style="cursor:pointer;">{{ scope.row.label }}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="remarks" label="备注说明" :show-overflow-tooltip="true" width="150" ></el-table-column>
            <el-table-column prop="isNeed" label="是否需要" width="65" >
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.need">应</el-tag>
                  <el-tag v-else>宜</el-tag>
                </template>
            </el-table-column> 
            <el-table-column prop="isOriginalView" label="原件" :show-overflow-tooltip="true" width="50" ></el-table-column>
            <el-table-column prop="isCopyView" label="复印件" :show-overflow-tooltip="true" width="55" ></el-table-column>
            <el-table-column prop="isScanView" label="扫描件" :show-overflow-tooltip="true" width="55" ></el-table-column>
            <el-table-column prop="isElectronicView" label="电子版" :show-overflow-tooltip="true" width="55" ></el-table-column>
            <el-table-column prop="fileTagNames" label="文件标签" :show-overflow-tooltip="true" width="150" ></el-table-column>
            <el-table-column prop="label" label="文件大小" width="70" :show-overflow-tooltip="true">
               <template slot-scope="scope">
                 <div v-if="scope.row.category===0"> {{scope.row.fileByteSize | getfilesize }} </div>
              </template>
            </el-table-column>
            <el-table-column prop="uploadUser" label="上传人" width="60"></el-table-column>
            <el-table-column prop="uploadTime" label="上传时间" :sortable="true" width="135"></el-table-column>
            <!-- <el-table-column prop="approvalStatusView" label="归档状态" :sortable="true" width="100"></el-table-column> -->
            <!-- <el-table-column prop="approvaler" label="审批人" :sortable="true" width="90"></el-table-column>
            <el-table-column prop="approvalTime" label="审批时间" :sortable="true" width="150"></el-table-column>
            <el-table-column prop="approveDesc" label="审批描述" :sortable="true" width="100"></el-table-column> -->
            <el-table-column fixed="right" label="操作" width="150" v-if="!isBelongApproval"> 
                <template slot-scope="scope">
                    <ProcessFiles v-if="scope.row.category===1 && isAvailable" style="float:left;height:28px;margin-right:15px" bizType="archiveInstance" :treeId="scope.row.id+''" :isIconUploadBtn="true" :treeName="scope.row.label" :modelInstanceId="modelInstanceId" :templateId="templateId" @getFileList="refreshFiles"/>
                    <el-button v-if="scope.row.category===1 && !isRead" type="info" size="mini" icon="el-icon-document-copy" title="选取并复制文件" circle @click.stop="handleChooseFile(scope.row)"></el-button> 
                    <el-button v-if="scope.row.category===0" type="primary" size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleDownLoad(scope.row)"></el-button>
                    <el-button v-if="scope.row.category===0" type="success" size="mini" icon="el-icon-view" title="预览" circle @click.stop="previewFile(scope.row)"></el-button>
                    <!-- <el-button v-permission="permission.archiveDeleteBtn" v-if="scope.row.category===0&&!isRead" type="danger" size="mini" icon="el-icon-delete"  title="删除" circle @click.stop="handleDelete(scope.row)"></el-button> -->
                    <el-button v-permission="permission.archiveDeleteBtn" v-if="scope.row.category===0" type="danger" size="mini" icon="el-icon-delete"  title="删除" circle @click.stop="handleDelete(scope.row)"></el-button>
                  </template>
            </el-table-column>
        </el-table>
        <!-- 简洁模式 -->
        <el-table 
        v-if="tableModelType == '2'"
        :key='loadTimer'
        :data="currentPageList"  
        ref="multipleTable"
        row-key="randomId" 
        default-expand-all
        style="width: 100%; " 
        max-height="520"
        :tree-props="{children: 'children'}"
        :cell-class-name="cellStyle"
        :border="true" 
        @select="handleSelect"
        @select-all="handleSelectAll"
        @selection-change="handleSelectionChange"
        v-loading="loading">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="orderNum" label="序号" width="80" aalign="left"> </el-table-column>
            <el-table-column prop="label" label="文件名称">
            </el-table-column>
            <el-table-column prop="remarks" label="备注说明" :show-overflow-tooltip="true" width="300" ></el-table-column>
            <el-table-column prop="label" label="文件大小" width="100" :show-overflow-tooltip="true">
               <template slot-scope="scope">
                 <div v-if="scope.row.category===0"> {{scope.row.fileByteSize | getfilesize }} </div>
              </template>
            </el-table-column>
            <el-table-column prop="uploadUser" label="上传人" width="100"></el-table-column>
            <el-table-column prop="uploadTime" label="上传时间" :sortable="true" width="135"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150" v-if="!isBelongApproval"> 
                <template slot-scope="scope">
                    <ProcessFiles v-if="scope.row.category===1 && isAvailable" style="float:left;height:28px;margin-right:15px" bizType="archiveInstance" :treeId="scope.row.id+''" :isIconUploadBtn="true" :treeName="scope.row.label" :modelInstanceId="modelInstanceId" :templateId="templateId" @getFileList="refreshFiles"/>
                    <el-button v-if="scope.row.category===1 && !isRead" type="info" size="mini" icon="el-icon-document-copy" title="选取并复制文件" circle @click.stop="handleChooseFile(scope.row)"></el-button> 
                    <el-button v-if="scope.row.category===0" type="primary" size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleDownLoad(scope.row)"></el-button>
                    <el-button v-if="scope.row.category===0" type="success" size="mini" icon="el-icon-view" title="预览" circle @click.stop="previewFile(scope.row)"></el-button>
                    <el-button v-permission="permission.archiveDeleteBtn" v-if="scope.row.category===0" type="danger" size="mini" icon="el-icon-delete"  title="删除" circle @click.stop="handleDelete(scope.row)"></el-button>
                  </template>
            </el-table-column>
        </el-table>
        <!-- <el-row type="flex" justify="end">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :total="page.totalPageNum"
                :current-page="page.currentPage"
                :page-size="page.pageSize"
                :page-sizes="[10, 20, 30, 50, 100]"
                @current-change="queryFormData"
                @size-change="queryFormDataByPageSize"
            />
        </el-row> -->

        <el-dialog
            title="选择复制文件"
            top="4vh"
            width="85%"
            :visible.sync="isShowFieldItemArchive"
            append-to-body
        >
        <FieldItemArchive ref="fieldItemArchive" v-if="isShowFieldItemArchive" :isRead="true" :key="loadTimer" :field="field2" :formData="formData2" :copyPageList="copySourceList"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowFieldItemArchive = false">取 消</el-button>
              <el-button type="primary" icon="el-icon-document-copy" @click.stop="handleCopyFileToTarget()">复制文件</el-button>
          </span>
        </el-dialog> 
  </div>
</template>

<script>

import FieldItemArchive from '@/components/FieldItem/FieldItemArchive';
import { API_FILE_DOWNLOAD, API_EXPORT_FORM_ARCHIVE_DIR_EXCEL,
    CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN,
    CONST_DOCUMENT_ARCHIVE_MODIFIED_BTN,
    CONST_DOCUMENT_ARCHIVE_DELETE_BTN } from '@/common/constants';
import { getArchiveTemplateTreeList, getFormFieldListByIds, copyFileToTarget, deleteArchiveTemplateFile, downloadFiles } from '@/data-model';
import ProcessFiles from '@/pages/process/components/ProcessFiles';
import { cloneDeep, isEmpty } from 'lodash';
import { getPreviewFileUrl, getUUID } from '@/utils/grocer';

export default {
    components: {
        ProcessFiles,
        FieldItemArchive
    },
    data () {
        return {
            defaultExpandAll: false,
            loadTimer: '',
            currentPageList: [],
            copySourceList: [], // 要复制的数据源
            formTreeFileList: [],
            multipleSelection: [],
            loading: false,
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            searchParams: {
                frontPageBreak: true, // 前段分页
                processServiceId: '', // 流程模板对应的方案ID
                startedByUserId: '', // 流程发起人ID
                assigneeUserId: '', // 流程负责人Id
                fromBI: true,
                hasSubProcess: '', // 默认全部
                isTree: true, // 树列表结构
                allProcessInstance: true, // 查询所有流程实例
                // processStartedBy: '', // 默认全部1我发起2我参与
                serviceName: '',
                state: '' // 流程状态 ：默认 全部
            },
            modelInstanceId: '',
            templateId: '',
            isShowFieldItemArchive: false,
            field2: {},
            formData2: {},
            archiveTreeRootId: '', // 默认复制到根目录文件夹下
            targetTemplateId: '', // 目标档案模板id
            businessTreeId: '', // 业务分类id
            loadTimerArchive: '',
            isShowArchiveTemplateList: false,
            permission: {
                archiveApprovalBtn: [// 业务档案文件审核
                    CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN
                ],
                archiveModifiedBtn: [// 业务档案文件修改
                    CONST_DOCUMENT_ARCHIVE_MODIFIED_BTN
                ],
                archiveDeleteBtn: [// 业务档案文件删除
                    CONST_DOCUMENT_ARCHIVE_DELETE_BTN
                ]
            },
            tableModelType: '1'
            // isEdit:false //是否可以修改业务分类和档案模板
            // isShowBusinessTree: this.field && this.field.options.config.type && this.field.options.config.type === 'multi', // 是否显示业务分类树
            // fieldSubType: this.field && this.field.options.config.type // 单选(按业务档案)  多选(按业务分类)
        };
    },
    props: {
        tableHeight: {
            type: Number,
            default: 280
        },
        field: {
            type: Object
        },
        formData: {
            type: Object,
            required: true
        },
        rootId: { // 获取节点树结构数据时的根节点id
            type: [ Number, String ]
        },
        isRead: {
            type: Boolean,
            default: false
        },
        fieldsList: {
            type: Array
        },
        copyPageList: {
            type: Array
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        isAvailable: {
            type: Boolean,
            default: true
        },
        isBelongApproval: {
            type: Boolean,
            default: false
        }
    },
    filters: {// 如下这样写
        getfilesize: function (size) {
            // console.log(size);
            if (!size) {
                return '';
            }
            var num = 1024.00; // byte
            if (size < num) { return size + '(B)'; }
            if (size < Math.pow(num, 2)) { return (size / num).toFixed(2) + '(K)'; } // kb
            if (size < Math.pow(num, 3)) { return (size / Math.pow(num, 2)).toFixed(2) + '(M)'; } // M
            if (size < Math.pow(num, 4)) { return (size / Math.pow(num, 3)).toFixed(2) + '(G)'; } // G
            return (size / Math.pow(num, 4)).toFixed(2) + '(T)'; // T
        }
    },
    computed: {
        selectedNode () {
            if (this.isShowBusinessTree) {
                let defaultVal = {
                    id: 0,
                    title: ''
                };
                if (this.formData && this.formData[this.field.id + '-archiveTreeId']) {
                    defaultVal.id = this.formData[this.field.id + '-archiveTreeId'];
                    defaultVal.title = this.formData[this.field.id + '-archiveTree'];
                    setTimeout(() => { // 调用子组件的方法
                        if (this.$refs.treeChild) {
                            this.$refs.treeChild._refreshSelectedNode(defaultVal);
                        }
                    }, 0);
                    this.isShowArchiveTemplateList = true;
                } else {
                    return defaultVal;
                }
            }
        },
        isEditAuth () { // 是否可以修改业务分类和档案模板
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            let isEditAuth = false;
            if (this.formData && this.formData.id) {
                isEditAuth = false;
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === this.permission.archiveModifiedBtn[0]) { // 是否可以点击进行数据修改
                                isEditAuth = true;
                                break;
                            }
                        }
                    }
                }
            } else {
                isEditAuth = true;
            }
            this.isShowArchiveTemplateList = true;
            return !isEditAuth;
        },
        selectedNodeTemplate () {
            if (this.isShowBusinessTree) {
                if (this.formData && this.formData[this.field.id + '-archiveId']) {
                    let defaultVal = {
                        id: 0,
                        label: ''
                    };
                    defaultVal.id = this.formData[this.field.id + '-archiveId'];
                    defaultVal.label = this.formData[this.field.id + '-archive'];
                    return defaultVal;
                }
            }
        },
        fieldSubType () {
            if (this.field && this.field.options && this.field.options.config) {
                return this.field.options.config.type;
            } else {
                return '';
            }
        },
        isShowBusinessTree () {
            return this.field && this.field.options && this.field.options.config && this.field.options.config.type === 'multi'; // 是否显示业务分类树
        }
    },
    created () {
        // 切换显示模式
        let ext2 = this.field.options.ext2;
        if (ext2) {
            let ext2Obj = JSON.parse(ext2);
            if (ext2Obj.profileTemplateType) {
                this.tableModelType = ext2Obj.profileTemplateType;
            } else {
                this.tableModelType = '1';
            }
        } else {
            this.tableModelType = '1';
        }
        this._initPage();
    },
    methods: {
        async _initPage () {
            await this._getFormData();
        },
        async _getFormData () {
            let loadingTemp = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // console.log(this.field);
            // console.log(this.formData);
            // console.log(this.fieldSubType);
            // console.log(this.copyPageList);
            // if (this.fieldSubType && this.fieldSubType === 'multi') { // 按业务分类查询

            // } else {

            // }
            if (Array.isArray(this.copyPageList) && this.copyPageList.length > 0) {
                this.currentPageList = this.copyPageList;
            } else {
                if (this.formData && this.formData.id) {
                    this.modelInstanceId = this.formData.id;
                } else {
                    if (!isEmpty(this.formData.tempModelInstanceId)) {
                        this.modelInstanceId = this.formData.tempModelInstanceId;// 使用上次的
                    } else {
                        this.modelInstanceId = getUUID(16, 16);// 生成16位临时表单实例主键
                        this.formData.tempModelInstanceId = this.modelInstanceId;
                    }
                }
                if (this.field && this.field.options.config.options[0] && this.fieldSubType !== 'multi') {
                    this.templateId = this.field.options.config.options[0].value;
                    // console.log(this.templateId);
                    if (this.templateId) {
                        await this.loadArchiveList();
                    }
                } else if (this.formData && this.fieldSubType === 'multi') {
                    this.templateId = this.formData[this.field.id + '-archiveId'];
                    // console.log(this.templateId);
                    if (this.templateId) {
                        await this.loadArchiveList();
                    }
                }
            }
            loadingTemp.close();
        },
        async loadArchiveList () {
            this.formTreeFileList = await getArchiveTemplateTreeList({templateId: this.templateId, modelInstanceId: this.modelInstanceId, hasChildFiles: true});
            console.log(this.formTreeFileList);
            if (this.formTreeFileList) {
                this.archiveTreeRootId = this.formTreeFileList[0].id;
                this.targetTemplateId = cloneDeep(this.templateId);
                this.page.totalPageNum = this.formTreeFileList.length;
                this.loadTimer = new Date().getTime();
                this.dealDataPage();// 分页
            }
        },
        dealDataPage () { // 前段分页
            // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
            let cpage = (this.page.currentPage - 1) * this.page.pageSize;
            let count = this.page.pageSize + cpage;
            this.currentPageList = this.formTreeFileList.slice(cpage, count);
        },
        queryFormData (currentPage) {
            this.page.currentPage = currentPage;
            this.dealDataPage();
        },
        queryFormDataByPageSize (pageSize) {
            this.page.pageSize = pageSize;
            this.dealDataPage();
        },
        handleTreeNode (data, node, tree) {
            this.formData[this.field.id + '-archiveTreeId'] = data.id;
            this.formData[this.field.id + '-archiveTree'] = data.label;
            this.businessTreeId = data.id + '';
            this.loadTimerArchive = new Date().getTime();
            this.isShowArchiveTemplateList = true;
            // console.log(this.formData);
        },
        async handleArchiveTemplateChange (node) {
            // console.log(node);
            this.formData[this.field.id + '-archiveId'] = node.id;
            this.formData[this.field.id + '-archive'] = node.label;
            this.templateId = node.id;
            // console.log(this.formData);
            await this.loadArchiveList();
        },
        async refreshFiles () {
            await this._getFormData();
            this.defaultExpandAll = true;
        },
        handleDownLoad (row) { // 下载
            // console.log(row);
            if (row.filePath) {
                let url = `${API_FILE_DOWNLOAD}${row.filePath}`;
                this.download(url);
            }
        },
        download (url) {
            // var iframe = document.createElement('iframe');
            // iframe.style.display = 'none';
            // iframe.src = url;
            // document.body.appendChild(iframe);
            downloadFiles(url);
        },
        async previewFile (file) {
            let transferObj = cloneDeep(file);// 更改id为文件id
            transferObj.id = transferObj.fileId;
            let previewUrl = await getPreviewFileUrl(transferObj);
            if (previewUrl) {
                let tempwindow = window.open();
                tempwindow.location = previewUrl;
            }
        },
        handleDelete (row) { // 删除
            this.$confirm('您确定要删除文件【' + row.fileName + '】吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // let delObj = {
                //   files:[row]
                // };
                let delObj = {
                    modelInstanceId: this.modelInstanceId,
                    files: [{id: row.fileId, category: row.category, templateId: row.templateId, createdBy: row.createdBy, approvalStatus: row.approvalStatus}]
                };
                await deleteArchiveTemplateFile(delObj);
                await this._getFormData();
                this.defaultExpandAll = true;
            });
        },
        handleSelect (selection, row, filter) {
            if (row.selected) {
                row.selected = false;
                this.$refs.multipleTable.toggleRowSelection(row, false);
            } else {
                if (filter) {
                    this.multipleSelection.push(row);
                }
                row.selected = true;
                this.$refs.multipleTable.toggleRowSelection(row, true);
            }
            if (row.children) {
                this.findChildrenNodes(row.children, !row.selected);
            }

            if (!filter) {
                this.setSelectedRow();
            }
            // console.log(this.multipleSelection);
        },
        handleSelectAll (selection) {
            // console.log(this.selectAll);
            // console.log(selection);
            this.multipleSelection = [];
            if (this.selectAll) {
                this.selectAll = false;
                this.$refs.multipleTable.clearSelection();
            } else {
                this.selectAll = true;
            }
            this.currentPageList.forEach(row => {
                row.selected = !this.selectAll;
                this.handleSelect(this.currentPageList, row, true);
            });
            // console.log(this.multipleSelection);
        },
        setSelectedRow () {
            this.multipleSelection = [];
            this.currentPageList.forEach(row => {
                if (row.selected) {
                    this.multipleSelection.push(row);
                }
                if (row.children) {
                    this.setChildrenNodes(row.children);
                }
            });
        },
        handleSelectionChange (val) {
            // console.log(val);
        },
        async handleChooseFile (row) {
            let sourceArchiveList = [];
            // console.log(this.fieldsList);
            // console.log(this.formData);
            // console.log(row);
            this.archiveTreeRootId = row.id;
            this.targetTemplateId = row.templateId;
            let chooseFieldArr = [];
            let chooseFieldMap = new Map();
            if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                this.copySourceList = [];
                this.fieldsList.forEach(item => {
                    // console.log(item);
                    if (this.formData[item.id].tableColumns) {
                        this.formData[item.id].tableColumns.forEach(subItem => {
                            if (subItem.type === 'archive' && this.formData[item.id].tableData) {
                                chooseFieldArr.push(subItem.id);
                                chooseFieldMap.set(subItem.id, this.formData[item.id].tableData[0].id);
                                sourceArchiveList.push(this.formData[item.id].tableData[0]);
                                // console.log(this.formData[item.id].tableData[0]);
                            }
                        });
                    }
                });
                // console.log(sourceArchiveList);
                if (Array.isArray(chooseFieldArr) && chooseFieldArr.length > 0) {
                    let chooseFields = chooseFieldArr.join(',');
                    // console.log(chooseFields);
                    let fieldArr = await getFormFieldListByIds(chooseFields);
                    // console.log(fieldArr);

                    if (Array.isArray(fieldArr) && fieldArr.length > 0) {
                        for (let i = 0; i < fieldArr.length; i++) {
                            let templateId = fieldArr[i].options.config.options[0].value;
                            // console.log(templateId);
                            let templateTreeData = await this.getCopyTemplateTreeData(templateId, chooseFieldMap.get(fieldArr[i].id));
                            // console.log(templateTreeData);
                            this.copySourceList.push(templateTreeData[0]);
                        }
                        this.loadTimer = new Date().getTime();
                        // console.log(this.copySourceList);
                        this.isShowFieldItemArchive = true;
                    } else {
                        this.$message({message: '没有对应的文件供复制，请选择关联数据后重试', type: 'warning'});
                    }
                }
            }
        },

        async getCopyTemplateTreeData (templateId, modelInstanceId) {
            let formTreeFileList = await getArchiveTemplateTreeList({templateId: templateId, modelInstanceId: modelInstanceId, hasChildFiles: true});
            return formTreeFileList;
        },

        handleCopyFileToTarget (target) {
            // console.log(target);
            // console.log(this.multipleSelection);
            let targetMultipleSelection = this.$refs.fieldItemArchive.getTargetFiles();
            if (targetMultipleSelection.length === 0) {
                this.$message({message: '请勾选要复制的文件', type: 'warning'});
            } else {
                // console.log(target);
            // this.$confirm('您确定要批量复制当前选中的文件到【' + target.name + '】吗？', '提示', {
                this.$confirm('您确定要批量复制当前选中的文件到当前【' + this.field.name + '】子表单中吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    targetMultipleSelection.forEach(item => {
                        // console.log(item);
                        item.id = this.archiveTreeRootId;
                        item.templateId = this.targetTemplateId;
                        item.modelInstanceId = this.modelInstanceId;
                    });
                    // console.log(targetMultipleSelection);
                    await copyFileToTarget(targetMultipleSelection);
                    this.isShowFieldItemArchive = false;
                    await this._getFormData();
                    this.defaultExpandAll = true;
                });
            }
        },
        findChildrenNodes (arr, pSelected) {
            arr.forEach(v => {
                if (pSelected) {
                    v.selected = false;
                    this.$refs.multipleTable.toggleRowSelection(v, false);
                } else {
                    this.multipleSelection.push(v);
                    v.selected = true;
                    this.$refs.multipleTable.toggleRowSelection(v, true);
                }
                if (v.children) {
                    this.findChildrenNodes(v.children, !v.selected);
                }
            });
        },
        setChildrenNodes (arr) {
            arr.forEach(v => {
                if (v.selected) {
                    this.multipleSelection.push(v);
                }
                if (v.children) {
                    this.setChildrenNodes(v.children);
                }
            });
        },
        getTargetFiles () {
            return this.multipleSelection;
        },
        async archiveDirExport () {
            let url = `${API_EXPORT_FORM_ARCHIVE_DIR_EXCEL}`;
            url = url.replace(':templateId', this.templateId).replace(':processInstanceId', '').replace(':hasChildFiles', true).replace(':modelInstanceId', this.modelInstanceId);
            downloadFiles(url);
        },
        cellStyle ({ row, column, columnIndex }) {
            if (columnIndex === 1) {
                return 'treeDocumentTableName';
            }
        }
    }
};
</script>

<style lang="less">
        .treeDocumentTableName{
            .cell{
                 display: flex;
                // .el-table__expand-icon{
                //     display: flex;
                // }
            }
        }
</style>



// WEBPACK FOOTER //
// src/components/FieldItem/FieldItemArchive.vue